<template>
  <m-accordion-primary class="m-accordion-dashboard" v-model="panel" ref="accordion">
    <template #default="accordion">
      <m-accordion-dashboard-content v-for="(criteria, id) in criterias"
                                     :key="id"
                                     :header="criteria.title"
                                     :parentIcon="parentIcon(criteria.name)"
                                     customToggle
                                     @content:toggle="toggleHandler($event, criteria)"
                                     :loading="$wait.waiting(criteria.name)"
                                     :ref="criteria._id">
        <div v-if="criteria.name==='risk_assessment'">
          <m-list-effectiveness :items="effectiveness" class="my-0"/>
        </div>
        <component v-else
                   :is="getRendererComponentName(criteria.viewType)"
                   v-bind="getRendererComponentProps(criteria)"
        ></component>
      </m-accordion-dashboard-content>
    </template>
  </m-accordion-primary>
</template>

<script>
import MAccordionPrimary from "@modules/accordions/types/m-accordion-primary";
import MAccordionDashboardContent from "@modules/accordions/includes/_m-accordion-dashboard-content";
import MListDashboardObjects from "@modules/lists/concrete/m-list-dashboard-objects";
import MListDashboardActions from "@modules/lists/concrete/m-list-dashboard-actions";
import MListDashboardAssessments from "@modules/lists/concrete/m-list-dashboard-assessments";
import MListEffectiveness from '@modules/lists/concrete/m-list-effectiveness';

import {mapActions, mapGetters} from 'vuex'
import vuexKeys from '@mixins/includes/_vuexKeys';
import {OBJECT_ACTIONS} from "@constants/common";

export default {
  name: "m-accordion-dashboard",
  components: {
    MAccordionPrimary,
    MListDashboardActions,
    MListDashboardObjects,
    MListDashboardAssessments,
    MAccordionDashboardContent,
    MListEffectiveness
  },
  data: () => ({
    panel: [],
  }),
  mixins: [vuexKeys],
  computed: {
    ...mapGetters({
      criterias: 'criterias/criterias',
      criteriaItems: 'criterias/getItems',
      getEffectivenessList: 'effectiveness/list'
    }),
    effectiveness() {
      return this.getEffectivenessList().slice(0, 5);
    }
  },
  async beforeMount() {
    await this.requestCriterias();
    this.clearItems();
    this.loadEffectiveness();
  },
  methods: {
    ...mapActions({
      requestCriterias: 'criterias/list',
      requestCriteriaItems: 'criterias/items',
      clearItems: 'criterias/clearItems',
      loadEffectiveness: 'effectiveness/list'
    }),
    getRendererComponentName(viewType) {
      switch (viewType) {
        case 'dashboard_actions':
          return 'm-list-dashboard-actions';
        case 'dashboard_assessments':
          return 'm-list-dashboard-assessments';
        default:
          return 'm-list-dashboard-objects';
      }
    },
    getRendererComponentProps(criteria) {
      const result = {
        items: this.criteriaItems(criteria.name)
      };
      switch (criteria.name) {
        case 'risk_assessment':
          break;
        case 'updated_objects':
        case 'not_risk_assessment':
          result.hiddenActions = [OBJECT_ACTIONS.manage];
          result.criteria = criteria.name;
          break;
        case 'ended_risk_assessment':
          result.hiddenActions = [OBJECT_ACTIONS.manage];
          result.criteria = criteria.name;
          break;
        default:
          break;
      }
      result.searchPath = criteria.path;
      return result;
    },
    async setCriteriaItems(criteria) {
      if (!this.criteriaItems(criteria.name)) {
        await this.requestCriteriaItems({path: criteria.path, key: criteria.name})
      }
    },
    async toggleHandler(event, criteria) {
      if (event.type === 'open') {
        await this.setCriteriaItems(criteria);
      }
      this.$refs[criteria._id][0].toggle();
    },
    parentIcon(name) {
      if (name === 'risk_assessment') {
        let answers = this.effectiveness.map(el => el.answer.answer)
        if (answers.includes('no'))
          return 'e-icon-effectiveness-no'
        else if (answers.includes('in_progress'))
          return 'e-icon-effectiveness-inprogress'
        else
          return undefined
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-accordion-dashboard {
  /deep/ .o-tile {
    .v-list {
      &__tile {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>
